import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { AdminShell } from "@/app/AdminShell";
import { adminElsewhere, adminUrl } from "@/lib/adminHost";
import { ApiError, api, qk, setActiveWorkspace, setCsrfToken, unwrap } from "@/lib/api";

/**
 * Platform admin console. Only `is_platform_admin` users get past here; everyone else sees the ordinary
 * not-found page, so the console's existence is not advertised. The API enforces `admin:platform` regardless, and
 * in production only on admin.guv.dev behind Cloudflare Access (lib/adminHost); other hosts are sent there.
 */
export const Route = createFileRoute("/admin")({
  beforeLoad: async ({ context, location }) => {
    if (adminElsewhere) throw redirect({ href: adminUrl(location.href), reloadDocument: true });
    // Admin calls cross workspaces; none of them should carry Guv-Workspace.
    setActiveWorkspace(null);
    try {
      const me = await context.queryClient.ensureQueryData({ queryKey: qk.me(), queryFn: () => unwrap(api.GET("/v1/me")) });
      setCsrfToken(me.csrf_token ?? null);
      if (me.user?.is_platform_admin !== true) throw notFound();
    } catch (e) {
      if (e instanceof ApiError && (e.status === 401 || e.code === "unauthorized")) {
        throw redirect({ to: "/login", search: { next: location.href } });
      }
      throw e;
    }
  },
  component: AdminShell,
});
